import React from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import * as S from "./style";
import { FiYoutube, FiInstagram, FiMessageCircle } from "react-icons/fi";
import artnguideW from "assets/images/iconFooter/artnguideW.svg";
import FamilySite from "components/FamilySite";

function MobileFooterMain() {
  const history = useHistory();
  const { dataCategoriesTerm } = useSelector(
    (state: any) => state.dataCategoriesTerm
  );

  return (
    <S.Wrapper id="footer">
      <S.Container>
        <S.Logo src={artnguideW} alt="ARTnGUIDE" />

          <S.Section>
            <S.Caption>COMPANY INFO</S.Caption>
            <S.CompanyName>
              <span className="name">(주)열매컴퍼니</span>
              <span className="sep">|</span>
              <span className="meta">
                <span className="key">대표자</span>
                <strong>김재욱</strong>
              </span>
            </S.CompanyName>
            <S.InfoLine>
              <span>사업자등록번호</span> 664-88-00573
            </S.InfoLine>
            <S.InfoLine>
              <span>통신판매업 신고번호</span> 2021-충남아산-0558호
            </S.InfoLine>
            <S.InfoLine>
              <span>개인정보관리책임자</span> 김재욱
            </S.InfoLine>
          </S.Section>

          <S.Section>
            <S.Caption>ADDRESS</S.Caption>
            <S.AddressBlock>
              <strong>본사</strong>
              <p>
                (31470)
                <br />
                충남 아산시 배방읍 희망로 46번길 45-11,
                <br />
                405호
              </p>
            </S.AddressBlock>
            <S.AddressBlock>
              <strong>지사</strong>
              <p>
                (04778)
                <br />
                서울 성동구 왕십리로 58, 312호
                <br />
                (서울숲포휴)
              </p>
            </S.AddressBlock>
          </S.Section>

          <S.Section>
            <S.Caption>SUPPORT</S.Caption>
            <S.SupportLabel>CS Center</S.SupportLabel>
            <S.PhoneBig>070-5015-0772, 0773</S.PhoneBig>
            <S.Email>cs@artnguide.com</S.Email>
            <S.Email>info@artnguide.com</S.Email>

            <S.SupportLabel>Operating Hours</S.SupportLabel>
            <S.HoursLine>평일 10:00 ~ 18:00</S.HoursLine>
            <S.HoursLine className="dim">점심시간 12:00 ~ 13:00</S.HoursLine>
            <S.HoursLine className="dim">
              * 주말 및 공휴일에는 상담이 어렵습니다
            </S.HoursLine>
          </S.Section>

        <S.Divider />

        <S.ContainerTerm>
          <S.BottomBar>
            <S.TermsList>
              {dataCategoriesTerm?.map((dt: any, i: any) => (
                <S.TermItem key={i} onClick={() => history.push(dt.location)}>
                  {dt.title}
                </S.TermItem>
              ))}
            </S.TermsList>

            <S.SnsRow>
              <S.SnsButton
                type="button"
                aria-label="youtube"
                onClick={() =>
                  window.open("https://www.youtube.com/@Artnguide", "_blank")
                }
              >
                <FiYoutube />
              </S.SnsButton>
              <S.SnsButton
                type="button"
                aria-label="instagram"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/artnguide?igsh=YXM1Mjdhb20wMng2",
                    "_blank"
                  )
                }
              >
                <FiInstagram />
              </S.SnsButton>
              <S.SnsButton
                type="button"
                aria-label="kakaoplus"
                onClick={() =>
                  window.open("https://pf.kakao.com/_ixgPNj", "_blank")
                }
              >
                <FiMessageCircle />
              </S.SnsButton>
            </S.SnsRow>
            <FamilySite fullWidth />
          </S.BottomBar>

          <S.TextMin>© Yeolmaecompany. all rights reserved</S.TextMin>
        </S.ContainerTerm>
      </S.Container>
    </S.Wrapper>
  );
}

export default MobileFooterMain;
